// RetroPill.jsx — compact status / role pill.
//
// Renders as a `.win95-chip` (1px chrome-outline border, Hanken 11px,
// sentence case) with soft brand fills per tone. Use for:
//   - role labels ("Chapter director", "LP")
//   - pitch review outcomes ("Favorite", "Ineligible")
//   - pitch pipeline status ("Grant winner", "Needs review")

import React from 'react';

// Tone → fill/text. Tokens only; fills mirror the review-list status chips.
const TONE_STYLES = {
  default: { background: 'var(--mb-chalk)',          color: 'var(--mb-ink)' },
  pink:    { background: 'var(--mb-magenta)',        color: 'var(--mb-chalk)' },
  blue:    { background: 'var(--mb-aqua-soft)',      color: 'var(--mb-ink)' },
  green:   { background: 'var(--green-mid)',         color: 'var(--mb-ink)' },
  yellow:  { background: 'var(--mb-butter)',         color: 'var(--mb-ink)' },
  purple:  { background: 'var(--mb-grape)',          color: 'var(--mb-chalk)' },
  error:   { background: 'var(--error-bg)',          color: 'var(--mb-ink)' },
  warn:    { background: 'var(--mb-tangerine-soft)', color: 'var(--mb-tangerine-deep)' },
};

export default function RetroPill({
  children,
  tone = 'default',
  icon,
  title,
  className = '',
}) {
  const toneStyle = TONE_STYLES[tone] || TONE_STYLES.default;
  const finalClass = className ? `win95-chip ${className}` : 'win95-chip';
  return (
    <span className={finalClass} style={toneStyle} title={title}>
      {icon != null && (
        <span aria-hidden="true" className="retro-pill__icon">
          {icon}
        </span>
      )}
      <span>{children}</span>
    </span>
  );
}
